module.exports = __webpack_public_path__ + "static/media/sp_duli.dbfd71e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/sp_duli.svg
// module id = 231
// module chunks = 0